import { render, staticRenderFns } from "./ChangeParentStatus.vue?vue&type=template&id=32143b82"
import script from "./ChangeParentStatus.vue?vue&type=script&lang=js"
export * from "./ChangeParentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports